import React from "react";
import { I } from "services/lang/LanguageService";
import { ISeparatorProps } from "./SeparatorTypes";

export default function Separator(props: ISeparatorProps) {
  return <h2 className="text-center">{I(props.title)}</h2>;
}
